import { useEffect, useMemo, useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { isContestRoute } from "../../../utils/commonMethods";

export function useGetProbeDataBuy(isPortfolio, probeId, probe) {
  let isContestRoute1 = isContestRoute();
  let liveState = useSelector(({ liveReducer }) => {
    const probe = {
      ...(isContestRoute1
        ? liveReducer?.byContestIds?.[probeId]
        : liveReducer?.byIds?.[probeId] || {}),
    };
    delete probe["volume"];
    delete probe["timestamp"];
    delete probe["channel"];
    return probe;
  }, shallowEqual);

  let live = liveState;
  let probeData = {};
  //const [probeData, setProbeData] = useState({});

  //useEffect(() => {
  if (live || probe) {
    var buyPriceYes = live?.newYCP ?? probe?.currentPrice?.newYCP;
    var buyPriceNo = live?.newNCP ?? probe?.currentPrice?.newNCP;

    probeData = {
      newYCP: buyPriceYes,
      newNCP: buyPriceNo,
    };
    // setProbeData(probeData1);
  }

  return probeData;
}
